"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _constant = require("../Theme/constant");

var _constant2 = require("./constant");

var _default = {
  PropTypes: {
    accessible: _propTypes.bool,
    customProperties: _propTypes.object,
    theme: _propTypes.string,
    imageURL: _propTypes.string,
    imageWidth: _propTypes.string,
    imageHeight: _propTypes.string,
    label: _propTypes.string,
    id: _propTypes.string,
    getData: _propTypes.func,
    labelTextType: _propTypes.string,
    ratingDesc: _propTypes.string,
    selectedSubtags: _propTypes.string,
    title: _propTypes.string,
    beforeIcon: _propTypes.string,
    afterIcon: _propTypes.string,
    editOptionNPS: _propTypes.bool,
    show: _propTypes.bool,
    openByDefault: _propTypes.bool,
    isCompact: _propTypes.bool
  },
  DefaultProps: {
    accessible: true,
    theme: _constant.DEFAULT_THEME,
    imageWidth: _constant2.DEFAULT_STYLES.IMAGE.WIDTH,
    imageHeight: _constant2.DEFAULT_STYLES.IMAGE.HEIGHT,
    data: {},
    getData: function getData() {},
    show: true,
    editOptionNPS: false,
    labelTextType: _constant2.DEFAULT_STYLES.LABEL.TYPE,
    openByDefault: false,
    isCompact: false
  }
};
exports.default = _default;